<template>
  <div>
    <b-skeleton-table v-if="fetchData" :rows="3" :columns="2" :table-props="{ bordered: true, striped: true }">
    </b-skeleton-table>
    <div class="subgroupReports" v-else>
      <h2>{{ survey.name }}</h2>
      <b-overlay :show="loadReport" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">

        <b-modal id="surveyDepartments" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
          modal-class="usersListPendingFull">
          <SurveyDepartmentReport :survey_id="surveyReport.id" :groupsWithSubgroupsOptions="groupsWithSubgroupsOptions"
            :selectedSurveyType="surveyReport.type" :coursesOptions="coursesOptions" :getCustomNames="getCustomNames" />
        </b-modal>

        <b-modal id="surveyClassesAndAdvisors" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
         modal-class="usersListPendingFull">
          <SurveyClassAndAdvisorReport :survey_id="surveyReport.id"
            :groupsWithSubgroupsOptions="groupsWithSubgroupsOptions" :selectedSurveyType="surveyReport.type"
            :coursesOptions="coursesOptions" :getCustomNames="getCustomNames" />
        </b-modal>

        <b-modal id="surveyClasses" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
          modal-class="usersListPendingFull">
          <SurveyClassReport :survey_id="surveyReport.id" :groupsWithSubgroupsOptions="groupsWithSubgroupsOptions"
            :selectedSurveyType="surveyReport.type" :coursesOptions="coursesOptions" :getCustomNames="getCustomNames" />
        </b-modal>

        <b-modal id="surveyParticipants" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
          hide-header :title="participantsReportTitle" modal-class="usersListPendingFull">
          <SurveyParticipantReport 
            :selectedSurveyType="survey.type"
            :groupsWithSubgroupsOptions="groupsWithSubgroupsOptions" 
            :survey_id="survey.id"
            :coursesOptions="coursesOptions" 
            :getCustomNames="getCustomNames"
            @close-report="handleCloseReport" />
        </b-modal>

        <table class="table-bordered table table-striped">
          <thead class="thead-dark">
            <tr>
              <th>Report Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="surveyAdmin">
              <td class="align-middle">
                <span v-if="surveyReport.type == 'hod_feedback'">HOD Feedback Survey Report (Single PDF File)</span>
                <span v-if="surveyReport.type == 'infrastructure_feedback'">Infrastructure Feedback Survey Report
                  (Single PDF File)</span>
                <span v-if="surveyReport.type == 'class_advisors_feedback'">Class Advisors Feedback Survey Report
                  (Single PDF File)</span>
              </td>
              <td class="align-middle text-center">
                <div>
                  <b-button size="sm" variant="danger" @click="generateSingleFileReport()">Download</b-button>
                </div>
              </td>

            </tr>
            <tr v-if="surveyAdmin">
              <td class="align-middle">
                <span v-if="surveyReport.type == 'hod_feedback'">HOD Feedback Survey Report (Separate Files)</span>
                <span v-if="surveyReport.type == 'infrastructure_feedback'">Infrastructure Feedback Survey Report
                  (Separate Files)</span>
                <span v-if="surveyReport.type == 'class_advisors_feedback'">Class Advisors Feedback Survey Report
                  (Separate Files)</span>
              </td>
              <td class="align-middle text-center">
                <div>
                  <b-button size="sm" variant="danger" @click="getTeacherFeedbackReport(survey.id)">Download</b-button>
                </div>
              </td>
            </tr>
            <tr v-if="surveyAdmin">
              <td class="align-middle">
                <span v-if="surveyReport.type == 'hod_feedback'">HOD Feedback Survey Report (Consolidated Data)</span>
                <span v-if="surveyReport.type == 'infrastructure_feedback'">Infrastructure Feedback Survey Report
                  (Consolidated Data)</span>
                <span v-if="surveyReport.type == 'class_advisors_feedback'">Class Advisors Feedback Survey Report
                  (Consolidated Data)</span>
              </td>
              <td class="align-middle text-center">
                <div>
                  <b-button @click="generateClassesSummaryReport(surveyReport.id)" variant="danger"
                    size="sm">Download</b-button>
                </div>
              </td>
            </tr>
            <tr>
              <td class="align-middle">Participants Report</td>
              <td class="align-middle text-center">
                <div>
                  <b-button size="sm" variant="primary" @click="
                    getParticipantsReport()
                    ">Views</b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </b-overlay>
    </div>
  </div>
</template>

<script>
import SurveyParticipantReport from '../reports/survey/SurveyParticipantReport.vue'
import SurveyDepartmentReport from '../reports/survey/SurveyDepartmentReport.vue'
import SurveyClassAndAdvisorReport from '../reports/survey/SurveyClassAndAdvisorReport.vue'
import SurveyClassReport from '../reports/survey/SurveyClassReport.vue'
import acl from "../../../../authorization/acl.js";
export default {
  props: ["surveyReport"],
  async created() {
    const isInstitutionAdmin = await acl.isUserGranted(
      "editInstituitionSettings"
    );
    this.surveyAdmin = isInstitutionAdmin;
    this.survey = this.surveyReport;
    await this.getGroupList();
  },
  components: {
    SurveyParticipantReport,
    SurveyDepartmentReport,
    SurveyClassAndAdvisorReport,
    SurveyClassReport
  },
  data() {
    return {
      survey: {},
      loadReport: false,
      fetchData: false,
      students: [],
      loadSurveyReport: false,
      groupsWithSubgroupsOptions: [],
      coursesOptions: [],
      participantsReportTitle: null,
      surveyAdmin: false,
      selectedReportType: 2,
    };
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
  },
  methods: {
    generateClassesSummaryReport(surveyId) {
      this.survey_id = surveyId;
      this.loadSurveyReport = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/usersubgroup/classessummaryreport/pdfexport`;
      this.$axios
        .post(
          url,
          {
            studfbsurvey: this.survey_id
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var tempFileName = null;

          const reportNames = {
            class_advisors_feedback: "Class Advisors Feedback Survey Report (Consolidated Data).pdf",
            hod_feedback: "HOD Feedback Survey Report (Consolidated Data).pdf",
            infrastructure_feedback: "Infrastructure Feedback Survey Report (Consolidated Data).pdf",
          };
          
          tempFileName = reportNames[this.surveyReport.type] || "Survey Report.pdf";

          link.setAttribute("download", tempFileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadSurveyReport = false;
        })
        .catch(() => {
          this.loadSurveyReport = false;
        });
    },
    generateSingleFileReport() {
      this.loadSurveyReport = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/${this.surveyReport.id}/report/pdfexport?custom_report=${this.reportType}&individualfiles=${this.singleorindividual == "individual" ? 1 : 0}&selected_report_type=${this.selectedReportType}`;
      this.$axios
        .post(
          url,
          {
            usersubgroup: null,
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var tempFileName = null;

          const reportNames = {
            class_advisors_feedback: "Class Advisors Feedback Survey Report (Single PDF File).pdf",
            hod_feedback: "HOD Feedback Survey Report (Single PDF File).pdf",
            infrastructure_feedback: "Infrastructure Feedback Survey Report (Single PDF File).pdf",
          };

          tempFileName = reportNames[this.surveyReport.type] || "Survey Report.pdf";

          link.setAttribute("download", tempFileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadSurveyReport = false;

        })
        .catch(() => {
          this.loadSurveyReport = false;
        });
    },

    handleCloseReport() {
      this.$bvModal.hide("surveyParticipants");
    },


    async getTeacherFeedbackReport(surveyId) {
      this.survey_id = surveyId;
      if (this.surveyReport.type == "hod_feedback") {
        this.$bvModal.show("surveyDepartments");
      }

      if (this.surveyReport.type == "class_advisors_feedback") {
        this.$bvModal.show("surveyClassesAndAdvisors");
      }

      if (this.surveyReport.type == "infrastructure_feedback") {
        this.$bvModal.show("surveyClasses");
      }
      this.loadSurveyReport = false;
    },
    async getParticipantsReport() {
      this.$bvModal.show("surveyParticipants");
    },

    getGroupList() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutionuser/usersubgroups`;
      this.$axios
        .get(url)
        .then((response) => {
          let custom =
            +this.getCustomNames.userSubgroup.custom_name != null
              ? "Select " + this.getCustomNames.userSubgroup.custom_name
              : "Select Usersubgroup";
          this.groupsWithSubgroupsOptions = [
            { value: null, text: custom, code: null, disabled: true },
          ];
          let groupSubgroup = response.data;

          if (this.surveyReport.type == 'infrastructure_feedback') {
            this.surveyReport.selected_usersubgroups = this.surveyReport.usersubgroup_ids;
          }
          groupSubgroup.forEach((subgroup) => {
            // Check if subgroup.id exists in selected_usersubgroups
            if (this.surveyReport.selected_usersubgroups.includes(subgroup.id)) {
              this.groupsWithSubgroupsOptions.push({
                value: subgroup.id,
                text: subgroup.usergroup.name + " - " + subgroup.name,
                code: subgroup.code + "-" + subgroup.usergroup.code,
              });
            }
          });
          response;
        })
        .catch((error) => {
          this.fetchData = false;
          error;
        });
    },
  },
};
</script>

<style>
.subgroupReports table tbody td:nth-child(2) {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.subgroupReportsEditAttendanceReport .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed;
}

.subgroupReportsEditAttendanceReport .modal-body {
  overflow: scroll;
}


.usersListPendingFull .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed !important;
  z-index: 100000;
}

.usersListPendingFull .modal-content {
  border-radius: 0 !important;
  height: 100vh;
  width: 100vw;
}

.usersListPendingFull .modal-body {
  overflow-y: auto;
  height: calc(100vh - 60px);
  /* header height */
}

</style>
